import { render } from "./CompanyDetailsForm.vue?vue&type=template&id=b89ca3de&scoped=true"
import script from "./CompanyDetailsForm.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsForm.vue?vue&type=script&lang=js"

import "./CompanyDetailsForm.vue?vue&type=style&index=0&id=b89ca3de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89ca3de"],['__file',"src/components/LoginFlow/CompanyDetailsForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b89ca3de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b89ca3de', __exports__)) {
    api.reload('b89ca3de', __exports__)
  }
  
  module.hot.accept("./CompanyDetailsForm.vue?vue&type=template&id=b89ca3de&scoped=true", () => {
    api.rerender('b89ca3de', render)
  })

}


export default __exports__